import React from 'react';

import { IconFacebook2 } from '@paretogroup/tess';
import { connect } from 'react-redux';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { bindActionCreators } from 'redux';

import { ColorConstants } from '@shared/constants';
import { createDefaultIntegration } from '../integration-strategies';
import {
    ID,
    FB_API_VERSION,
    FB_APP_ID,
    FIELDS,
    SLOT_TITLE,
    SCOPE,
    TEST_ID,
    APPCUES_ID,
} from './facebook-integration.constants';
import {
    saveFacebookIntegration,
    openFacebookIntegration,
    closeFacebookIntegration,
} from './facebook-integration.state';
import { ICON_SIZE } from '../integrations.constants';


const { Component: SlotItem } = createDefaultIntegration({
    id: ID,
    title: SLOT_TITLE,
    icon: <IconFacebook2
        primaryColor={ColorConstants.FUN_BLUE}
        size={ICON_SIZE}
    />,
    isDisabled: false,
    testId: TEST_ID,
    dataAppcuesId: APPCUES_ID,
});

type Props = {
  save: (accessToken: string) => void
  onOpenModal: () => void
  onCloseModal: () => void
}

const FacebookIntegrationImpl = ({
    save,
    onOpenModal,
    onCloseModal,
    ...anotherProps
}: Props) => {
    const handleResponse = ({ accessToken }) => {
        if (!accessToken) return onCloseModal();

        return save(accessToken);
    };

    return (
        <FacebookLogin
            onClick={onOpenModal}
            appId={FB_APP_ID}
            autoLoad={false}
            callback={handleResponse}
            version={FB_API_VERSION}
            fields={FIELDS}
            render={renderProps => (
                <SlotItem onClick={renderProps.onClick} {...anotherProps} />
            )}
            scope={SCOPE}
        />
    );
};

const FacebookIntegration = connect(
    null,
    dispatch => bindActionCreators({
        save: saveFacebookIntegration,
        onOpenModal: openFacebookIntegration,
        onCloseModal: closeFacebookIntegration,
    }, dispatch),
)(FacebookIntegrationImpl);

export const facebookIntegration = {
    id: ID,
    Component: FacebookIntegration,
};
